import { PAYMENT_RESPONSE_SET, PAYMENT_RESPONSE_REMOVE } from '../../actions/payment-response/types';

const emptyState = {};

export default function paymentResponse(state = emptyState, { type, data }) {
  switch (type) {
    case PAYMENT_RESPONSE_SET:
      return {
        ...emptyState,
        ...data,
      };
    case PAYMENT_RESPONSE_REMOVE:
      return emptyState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/payment-response/index.js